import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {AddAddressPresenter} from "./addAddressPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class AddAddressView extends ViewBase implements IView {

    public _presenter: AddAddressPresenter;

    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);
    }

    public get streetAddressOne() {
        return this.getValueById('street-address-one');
    }

    public set streetAddressOne(value) {
        this.setValueById('street-address-one', value);
    }

    public get streetAddressTwo() {
        return this.getValueById('street-address-two');
    }

    public set streetAddressTwo(value) {
        this.setValueById('street-address-two', value);
    }

    public get city() {
        return this.getValueById('city');
    }

    public set city(value) {
        this.setValueById('city', value);
    }

    public get stateProvinceRegion() {
        return this.getValueById('state-province-region');
    }

    public set stateProvinceRegion(state) {
        this.setValueById('state-province-region', state);
    }

    public get zipPostalCode() {
        return this.getValueById('zip-postal-code');
    }

    public set zipPostalCode(value) {
        this.setValueById('zip-postal-code', value);
    }

    public setPresenter(presenter: AddAddressPresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }

}